<template>
  <NavBar active-profile="rasha" />
  <HomeHero
    :image-src="rashaCortiImage"
    image-alt="Rasha Corti"
    hero-class="rasha-hero"
    hero-eyebrow="Syria Market Entry Advisor · Partner Matching &amp; Market Facilitation"
    person-name-de="Finding the right partners.<br />De-risking market entry."
    person-name-en="Finding the right partners.<br />De-risking market entry."
    :about-text="aboutText"
    :show-language-switcher="false"
    :show-about-headline="false"
    desktop-spacer-height="360px"
  >
    <template #after-text>
      <NewsButton />
    </template>
  </HomeHero>
  <RashaProfessionalExperience />
  <ContactPage
    ref="#contact"
    email="rasha.corti@ajl-advisors.com"
    phone="+43 680 1155152"
    phone-href="+436801155152"
  />
  <FooterBar />
</template>

<script>
import HomeHero from "./HomeHero.vue";
import NewsButton from "./NewsButton.vue";
import NavBar from "./Nav.vue";
import RashaProfessionalExperience from "./RashaProfessionalExperience.vue";
import ContactPage from "./Contact.vue";
import FooterBar from "./FooterBar.vue";
import rashaCortiImage from "../assets/rasha-corti.png";

export default {
  name: "RashaCorti",
  components: {
    HomeHero,
    NewsButton,
    NavBar,
    RashaProfessionalExperience,
    ContactPage,
    FooterBar,
  },
  data() {
    return {
      aboutText:
        "Expert advisor connecting organizations with vetted local partners and legal professionals in Syria. Helping organizations identify and connect with the right partners—business, legal, regulatory—for successful market entry and operations in Syria.",
      rashaCortiImage,
    };
  },
  mounted() {
    this.$i18n.locale = "en";
    this.setMeta();
  },
  methods: {
    setMeta() {
      document.title = "Rasha Corti, MSc | Syria Market Entry Advisor";
      this.setMetaTag("name", "description", this.aboutText);
      this.setMetaTag(
        "property",
        "og:title",
        "Rasha Corti, MSc | Syria Market Entry Advisor"
      );
      this.setMetaTag("property", "og:description", this.aboutText);
      this.setMetaTag(
        "property",
        "og:image",
        `${window.location.origin}/rasha-corti.png`
      );
    },
    setMetaTag(attribute, key, content) {
      let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    },
  },
};
</script>
